import Link from "astro-typesafe-routes/link/react";
import plur from "plur";
import { match } from "ts-pattern";

import { MAX_FREE_ASSIGNMENTS, MAX_FREE_PACKS } from "~/utils/const";

import { Alert } from "./Alert";

export const QuotaAlert: React.FC<{
  quota: number;
  type: "pack" | "assignment";
}> = ({ quota, type }) => {
  if (!isFinite(quota)) {
    // if the user has a paid membership, quota will be Infinity
    return null;
  }

  const max = match(type)
    .with("pack", () => MAX_FREE_PACKS)
    .with("assignment", () => MAX_FREE_ASSIGNMENTS)
    .exhaustive();

  if (quota === max) {
    // don't show the quota alert if the user hasn't made a dent yet
    return null;
  }

  return (
    <Alert
      type="warning"
      description={
        <>
          <Link to="/account/billing" className="link">
            Upgrade your account
          </Link>{" "}
          for unlimited access
        </>
      }
    >
      You have {quota} free {plur(type, quota)} remaining.
    </Alert>
  );
};
